import { Warning } from '@mui/icons-material';
import { Alert } from '@mui/material'
import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const ALERT_COLOR = "#ffbc0d"

export default function CompleteProfileInfoAlert({
    variant = "filled",
    forceOpen = false,
    dismissible = true,
    fallbackMessage,
    sx,
}) {
    const { profile } = useSelector((state) => state.entities.profile)
    const { credits } = useSelector((state) => state.entities.creditsAndSubscription)

    const [openAlert, setOpenAlert] = useState(forceOpen);

    const [isidDocumentCompleted, setIsidDocumentCompleted] = useState(true)
    const [isWalletNotChargedBefore, setIsWalletNotChargedBefore] = useState(true)

    useEffect(() => {
        const user = profile?.merchant
        if (!!user && (forceOpen || user?.currentStatus !== "ACTIVE")) {
            const idDocumentCompleted = !!user?.idDocument?.name
            setIsidDocumentCompleted(idDocumentCompleted)

            const walletNotChargedBefore = credits <= 0 && user?.currentStatus === "WAITING"
            setIsWalletNotChargedBefore(walletNotChargedBefore)

            if (idDocumentCompleted && !walletNotChargedBefore) {
                setOpenAlert(forceOpen)
            } else {
                setOpenAlert(true)
            }
        }

    }, [profile, credits, forceOpen]);

    const isOutlined = variant === "outlined"
    const linkStyle = {
        color: isOutlined ? "inherit" : "white",
        textDecoration: "underline",
    }
    const hasPendingActions = isWalletNotChargedBefore || !isidDocumentCompleted

    return (
        <>
            {
                openAlert ?
                    <Alert
                        variant={variant}
                        icon={<Warning />}
                        onClose={dismissible ? () => setOpenAlert(false) : undefined}
                        sx={{
                            mb: 1,
                            mx: 1,
                            ...(isOutlined
                                ? {
                                    borderColor: ALERT_COLOR,
                                    color: "text.primary",
                                    "& .MuiAlert-icon": { color: ALERT_COLOR },
                                }
                                : { bgcolor: ALERT_COLOR, color: "black" }),
                            ...sx,
                        }}
                    >
                        {(!hasPendingActions && !!fallbackMessage) ? fallbackMessage : (
                            <>
                                {t("Please note that to start using our services, you are required to")}
                                &nbsp;
                                {isWalletNotChargedBefore &&
                                    <span>
                                        &nbsp;
                                        <Link style={linkStyle} to="/merchant/balance" target='_blank'>{t("charge your wallet")}</Link>
                                    </span>
                                }
                                {(!isidDocumentCompleted && isWalletNotChargedBefore) &&
                                    <span>&nbsp;{t("and")}&nbsp;</span>
                                }
                                {!isidDocumentCompleted &&
                                    <span>
                                        <Link style={linkStyle} to="/merchant/account/info" target='_blank'>{t("upload the photo of your ID or residency permit")}</Link>
                                        &nbsp;
                                    </span>
                                }
                                .
                            </>
                        )}
                    </Alert> :
                    <></>
            }
        </>
    )
}
